import { prefixKey } from '@/utils/storagePrefix';

const COMPANY_STORAGE_KEY = prefixKey('timetrack_current_company');

export function getStoredCompany(): string | null {
  try {
    return localStorage.getItem(COMPANY_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to get stored company:', error);
    return null;
  }
}

export function setStoredCompany(companyId: string): void {
  try {
    localStorage.setItem(COMPANY_STORAGE_KEY, companyId);
  } catch (error) {
    console.error('Failed to store company:', error);
  }
}

export function clearStoredCompany(): void {
  try {
    localStorage.removeItem(COMPANY_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear stored company:', error);
  }
}

// Cache storage functions
export function getCachedCompanyData<T>(companyId: string, key: string): T | null {
  try {
    const cacheKey = `timetrack_cache_${companyId}_${key}`;
    const cached = sessionStorage.getItem(cacheKey);
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    console.error('Failed to get cached company data:', error);
    return null;
  }
}

export function cacheCompanyData<T>(companyId: string, key: string, data: T): void {
  try {
    const cacheKey = `timetrack_cache_${companyId}_${key}`;
    sessionStorage.setItem(cacheKey, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to cache company data:', error);
  }
}

export function clearCompanyCache(companyId: string): void {
  try {
    const prefix = `timetrack_cache_${companyId}_`;
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  } catch (error) {
    console.error('Failed to clear company cache:', error);
  }
}

// Named export for compatibility with index.ts
export const companyStorage = {
  get: getStoredCompany,
  set: setStoredCompany,
  clear: clearStoredCompany,
  getCachedCompanyData,
  cacheCompanyData,
  clearCompanyCache,
};
